


































































































import { Vue, Component, Prop, Ref} from 'vue-property-decorator'
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { SmsTextInputWings } from '@/components/SMS';
import { MsgTransports } from '@/store/types';
import { TemplateItemImpl } from '@/store/settings/templates/types';
import { Route } from 'vue-router';
import {ViberTemplateItem, uploadedFile, ViberGenericTemplateInterface} from '@/store/viber/templates/types';
import upload from "@/components/Inputs/upload.vue";
import {Action} from "vuex-class";
import { notifyError } from '@/utils/notify-helper';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericTemplate, SmsTextInputWings, upload}})
export default class ViberTemplate extends Vue {

  @Prop() moderation!: boolean;

  @Ref('genericTemplate') genericTemplate!: ViberGenericTemplateInterface;

  @Action("getFile") actionGetFile: any;
  @Action("uploadFiles") actionUploadFiles: any;
  @Action("deleteFile") actionDeleteFile: any;

  private transport: MsgTransports = MsgTransports.VIBER;
  private templateObject: ViberTemplateItem = new TemplateItemImpl();
  uploadedFile?: uploadedFile | null = null;
  acceptedFiles = `.doc, .docx, .rtf, .dot, .dotx, .odt, .odf, .fodt, .txt, .info,
    .pdf, .xps, .pdax, .eps, .xls, .xlsx, .ods, .fods, .csv, .xlsm, .xltx`;

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }

  async onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status);
    }
  }

  async onChangeTemplate(template: ViberTemplateItem) {
    if (template.attachment_file_id) {
      try {
        const resp = await this.actionGetFile(template.attachment_file_id);
        this.uploadedFile = resp.data;
      } catch(error) {
        notifyError(error)
      }
    }
  }

  async onFileChanged(event: any) {
    if (!event.target.files[0]) return;
    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    try {
      const resp = await this.actionUploadFiles(formData);
      this.uploadedFile = resp.data;
      this.genericTemplate.template.attachment_file_id = resp.data?.id;
      this.genericTemplate.template.button_link = undefined;
      this.genericTemplate.template.image_link = undefined;
    } catch(error) {
      notifyError(error);
    }
  }

  async deleteFile() {
    try {
      await this.actionDeleteFile(this.uploadedFile?.id);
      this.genericTemplate.template.attachment_file_id = null;
      this.uploadedFile = null;
    } catch(error) {
      notifyError(error)
    }
  }

  onPasteEventHandler(event: any) {
    if (event?.clipboardData?.files?.length > 0) {
      //@ts-ignore
      this.$refs.fileInput.files = event.clipboardData.files;
      //@ts-ignore
      this.$refs.fileInput.dispatchEvent(new Event('change'));
    }
  }

  onDropEventHandler(event: any) {
    if (event?.dataTransfer?.files?.length > 0) {
      //@ts-ignore
      this.$refs.fileInput.files = event.dataTransfer.files;
      //@ts-ignore
      this.$refs.fileInput.dispatchEvent(new Event('change'));
    }
  }

  private customValidateTemplate(): string | undefined {
    const template = this.genericTemplate.template;

    const hasText = !!template.message?.trim();
    const hasImage = !!template.image_link?.trim();
    const hasButtonName = !!template.button_name?.trim();
    const hasButtonLink = !!template.button_link?.trim();
    const hasFile = !!template.attachment_file_id;

    if (hasButtonName && !hasButtonLink && !hasFile) {
      return this.$tc('errors.viber_button_requires_link_or_file');
    }

    if (!hasText && !hasImage && !hasButtonName && !hasButtonLink && !hasFile) {
      return this.$tc('errors.viber_custom_content_validation');
    }
  }

  mounted() {
    const originalValidate = this.genericTemplate.validator.validate;

    this.genericTemplate.validator.validate = async (...args: any[]): Promise<boolean> => {
      const baseValid = await originalValidate.apply(this.genericTemplate.validator, args);
      const customError = this.customValidateTemplate();

      if (customError) {
        this.genericTemplate.validator.errors._content = [customError];
        return false;
      }

      return baseValid;
    };
  }
}
